export const environment = {
    production: false,
    title: 'Production AWS - Purolator - BIP',
    apiURL:  'https://bip-ui.finservices.aws-purolator.com'
  };
  